/* global Promise */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('FixSubscriptionController', FixSubscriptionController);

    FixSubscriptionController.$inject = ['debug', 'API', 'i18n', '$scope',];

    function FixSubscriptionController(debug, API, i18n, $scope) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.submit = submit;
        vm.isSubmitting = false;
        vm.subscriptionPlans = [];

        vm.data = {
            group_id: 0,
            provider: 'Stripe',
        };

        activate();

        function activate() {
            loadSubscriptionPlans().then(function(){
                vm.data.group_id = $scope.placeholders.groupId;
                vm.subscription = $scope.placeholders.subscription;

                if (vm.subscription) {
                    vm.data.provider = vm.subscription.provider;
                    vm.data.status = vm.subscription.status;
                    vm.data.reference = vm.subscription.reference;
                    vm.data.customer_reference = vm.subscription.customer_reference;
                    vm.data.subscription_plan_id = vm.subscription.fk_plan_id;
                    vm.data.date_end = vm.subscription.date_end;
                    vm.data.trial_end = vm.subscription.trial_end;
                }

                if (vm.data.date_end && vm.data.trial_end && vm.data.date_end.match(/^\d{4}-\d{2}-\d{2}$/) && vm.data.trial_end.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
                    vm.data.date_end += ' ' + vm.data.trial_end.split(' ')[1];
                }
            }, function(){});
        }

        function loadSubscriptionPlans() {
            return new Promise(function(resolve, reject){
                API.SubscriptionPlan.getCached()
                    .$promise
                    .then(function (response) {
                        angular.forEach(response.items, function (plan) {
                            vm.subscriptionPlans.push({
                                value: plan.id,
                                label: plan.name,
                                subLabel: plan.price + ' ' + plan.currency + ' per ' + plan.recurrence_months + ' month(s)',
                            });
                        });

                        resolve();
                    }, reject);
            });
        }

        function submit() {
            if (!vm.isSubmitting) {
                vm.isSubmitting = true;

                API.Subscription.fix(vm.data).$promise.then(function(response){
                    $scope.$parent.submit(response);
                }, function(){});
            }
        }
    }
})();